var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyOptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 14",
    style: {
      enableBackground: "new 0 0 30 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0066FF;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#0066FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "final---dec.11-2020_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_208-our-toggle_2_",
    transform: "translate(-1275.000000, -200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Final-Copy-2_2_",
    transform: "translate(1275.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.4,12.8h6.8l3.1-11.6H7.4C4.2,1.2,1.6,3.8,1.6,7S4.2,12.8,7.4,12.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "final---dec.11-2020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_208-our-toggle",
    transform: "translate(-1275.000000, -200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Final-Copy-2",
    transform: "translate(1275.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.6,0H7.4c-3.9,0-7,3.1-7,7s3.1,7,7,7h15.2c3.9,0,7-3.1,7-7S26.4,0,22.6,0z M1.6,7c0-3.2,2.6-5.8,5.8-5.8 h9.9l-3.1,11.6H7.4C4.2,12.8,1.6,10.2,1.6,7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "st2",
    d: "M24.6,4c0.2,0.2,0.2,0.6,0,0.8l0,0L22.5,7l2.2,2.2c0.2,0.2,0.2,0.6,0,0.8c-0.2,0.2-0.6,0.2-0.8,0 l0,0l-2.2-2.2L19.5,10c-0.2,0.2-0.6,0.2-0.8,0c-0.2-0.2-0.2-0.6,0-0.8l0,0L20.8,7l-2.2-2.2c-0.2-0.2-0.2-0.6,0-0.8 c0.2-0.2,0.6-0.2,0.8,0l0,0l2.2,2.2L23.8,4C24,3.8,24.4,3.8,24.6,4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "st3",
    d: "M12.7,4.1c0.2,0.2,0.3,0.6,0.1,0.8l0,0L8.6,9.8C8.5,9.9,8.4,10,8.3,10c-0.2,0.1-0.5,0.1-0.7-0.1l0,0 L5.4,7.7c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0l0,0L8,8.6l3.8-4.5C12,3.9,12.4,3.9,12.7,4.1z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyOptions);
export default __webpack_public_path__ + "static/media/privacyOptions.db63fc7bb7bf929720f31167082dd064.svg";
export { ForwardRef as ReactComponent };